import React, {useState, useEffect} from 'react'

import "./Companies.css"
import Sidebar from "../../shared/sidebar/Sidebar"
import Navbar from "../../shared/navbar/Navbar"
import DataTable from "../../shared/datatable/DataTable"
import axios from 'axios'
import CompanyEditor from './Editor'
import { format } from 'fecha';
import ErrorMessages from '../../shared/errormessages/ErrorMessages';

const Companies = () => {

  const [editorState, setEditorState] = useState({open: false, data: null})
  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })

  const [errors, setErrors] = useState("")
  const [search, setSearch] = useState("")

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/companies/getlist?search=' + search)
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const model = {
    columns: [
      {
        field: "Name",
        headerName: "Company",
        width: 230,
        renderCell: (params) => {
          return (
            <div className="cellWithImg" onClick={()=> handleOnCellClick(params)}>
              <img className="cellImg company-image" src={axios.defaults.baseURL + '/' + params.row.Logo} alt="avatar" />
              <a className="cellWithLink">{params.row.Name}</a>
            </div>
          );
        },
      },
      {
          field: "Industry",
          headerName: "Industry",
          width: 150
      },
      {
          field: "PhoneNumber",
          headerName: "Phone",
          width: 150,
        },
        {
          field: "Address",
          headerName: "Address",
          width: 200,
        },
        {
          field: "ValidityDate",
          headerName: "Validity",
          width: 110,
          type: 'date',
          valueGetter: ({ value }) => value && new Date(value)
        },
        {
          field: "UserLimit",
          headerName: "Users/Limit",
          width: 100,
          renderCell: (params) => {
            return (
              <div><b>{params.row.NoOfUsers}</b>/{params.row.UserLimit}</div>
            );
          }
        },
        {
          field: "CanManageSituations",
          headerName: "Allow Deep Analysis",
          width: 150,
          renderCell: (params) => {
            return (
              <div className={`cellWithStatus ${params.row.CanManageSituations}`}>
               <span>{params.row.CanManageSituations && "YES"}{!params.row.CanManageSituations && "NO"}</span>
              </div>
            );
          },
        },
        {
          field: "CanAccess",
          headerName: "Allow Access?",
          width: 150,
          renderCell: (params) => {
            return (
              <div className={`cellWithStatus ${params.row.CanAccess}`}>
               <span>{params.row.CanAccess && "YES"}{!params.row.CanAccess && "NO"}</span>
              </div>
            );
          },
        },
        {
          field: "EnableVideos",
          headerName: "Enable Video?",
          width: 150,
          renderCell: (params) => {
            return (
              <div className={`cellWithStatus ${params.row.EnableVideos}`}>
               <span>{params.row.EnableVideos && "YES"}{!params.row.EnableVideos && "NO"}</span>
              </div>
            );
          },
        },
        {
          field: "ModifiedBy",
          headerName: "Modified By",
          width: 120,
        },
        {
          field: "ModifiedOn",
          headerName: "Modified On",
          width: 150,
          renderCell: (params)=>{
            return(
              params.row.ModifiedOn &&
              <span>{format(new Date(params.row.ModifiedOn), 'DD/MM/YYYY HH:mm')}</span>
            );
          }
        }
    ],
    modulename: "Companies"
  };

  const handleOnCellClick = (params) => {
    setEditorState({ open: true, data: params.row});
  };

  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar title={model.modulename}/>
        <ErrorMessages message={errors}/>
        {
          editorState.open == true ? 
          <CompanyEditor data={editorState} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors} /> : 
          <DataTable  {...model} rows={pageData.data} checkboxSelection={true} setEditorState={setEditorState} setPageState={setPageState} setErrors={setErrors}
          setSearch={setSearch} />
        }
      </div>
    </div>
  )
}

export default Companies